<div class="main">
  <div class="header"><app-header></app-header></div>
  <div class="router-content"><router-outlet /></div>
</div>
